import { Route } from 'src/routes/Route'

export const DraftedOrdersRoute = Route({ path: '/drafted-orders' })
export type DraftedOrdersRoute = Route<typeof DraftedOrdersRoute>
